import {
    Alert,
    AlertIcon,
    Avatar,
    AvatarBadge,
    Box,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Button,
    ButtonGroup,
    Flex,
    FormControl,
    FormLabel,
    Grid,
    GridItem,
    Heading,
    Input,
    InputGroup,
    InputRightElement,
    Select,
    Stack,
    Text,
    Textarea,
    useColorModeValue,
    useToast,
    Badge,
    IconButton,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Resizer from "react-image-file-resizer";
import { CloseIcon, AttachmentIcon } from "@chakra-ui/icons";
import { AiOutlinePlus } from "react-icons/ai";
import {
    Step,
    StepDescription,
    StepIcon,
    StepIndicator,
    StepNumber,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    useSteps,
} from "@chakra-ui/react";
import axiosClient from "../../../axios-client";
import { useStateContext } from "../../../context/ContextProvider";
import { handlePriceChange, formatPriceForBackend } from "../../../utils/priceFormatter";




function AddStock() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const steps = [
        { title: "Images" },
        { title: "Infos" },
        { title: t("Propriétés") },
    ];
    const { user, setToken, setUser, dataSubscriptionUser, getAbonnementClient, currentBusiness } = useStateContext()

    const [imageListe, setimageListe] = useState([]);
    const [selectedImageList, setSelectedImageList] = useState([]);
    const [loadingImg, setLoadingImg] = useState(false);
    const [inputKey, setInputKey] = useState(0);

    const { activeStep, setActiveStep } = useSteps({ index: 0 });

    //MESSAGES ERROR
    const [messageErrImages, setMessageErrImages] = useState('')
    const [messageErrTitle, setMessageErrTitle] = useState('')

    // data Categories
    const [categoriesOptions, setCategoriesOptions] = useState([])
    const [selectedCategory, setSelectedCategory] = useState(null);

    const fetchDataCategories = async () => {
        try {
            await axiosClient.get(`/categories/getAllCategories/?page_size=100&page=1&&client=${user?.id}&userRole=${user?.role}`).then(res => {


                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }

                const categories = res.data.results.map(cat => ({
                    value: cat.id,
                    label: cat.name
                }));
                setCategoriesOptions(categories)
            })
        } catch (error) {
            // // console.error('Error : ', error);

        }
    }

    useEffect(() => {
        if (user?.id) {
            fetchDataCategories()
        }
    }, [user?.id])

    // function display images
    const handleChangeImage = (e) => {
        const images = e.target.files;
        const extensions = [".png", ".jpg", ".jpeg", ".webp"];

        if (images && images.length > 0) {
            if (selectedImageList.length + images.length > 5) {
                toast({
                    description: t("Vous ne pouvez séléctionner que 5 images au maximum !"),
                    status: "warning",
                    variant: "left-accent",
                    duration: 2000,
                    isClosable: true,
                    position: "top-center",
                });
                setInputKey((prevKey) => prevKey + 1);
                return;
            }
            const selectedImages = Array.from(images);

            selectedImages.forEach(async (image) => {
                if (image.name.length > 60) {
                    toast({
                        description: t(
                            "Nom de l'image dépasse 60 caractères! Veuillez modifier le nom ! "
                        ),
                        status: "warning",
                        variant: "left-accent",
                        duration: 2000,
                        isClosable: true,
                        position: "top-center",
                    });
                } else if (
                    !extensions.includes(
                        image.name.substring(image.name.lastIndexOf("."))
                    )
                ) {
                    toast({
                        title: t("Erreur d'extension."),
                        description: t(
                            "Veuillez modifier l'extension de l'image {'[*.png, *.jpg, *.jpeg, *.webp]'} !"
                        ),
                        status: "warning",
                        variant: "left-accent",
                        duration: 2000,
                        isClosable: true,
                        position: "top-center",
                    });
                } else {
                    const imageURL = URL.createObjectURL(image);
                    const uri = await new Promise((resolve, reject) => {
                        Resizer.imageFileResizer(
                            image,
                            451,
                            800,
                            "png",
                            100,
                            0,
                            (uri) => {
                                resolve(uri);
                            },
                            "file"
                        );
                    });
                    setimageListe((prevImageList) => [...prevImageList, uri]);
                    setSelectedImageList((prevSelectedImages) => [
                        ...prevSelectedImages,
                        imageURL,
                    ]);
                }
            });

            // Reset the input value after processing all selected images
            setInputKey((prevKey) => prevKey + 1);
        }
    };

    //inputs info produits
    const [titreProduit, setTitreProduit] = useState('')
    const [descriptionProduit, setDescriptionProduit] = useState('')

    const today = new Date().toISOString().split('T')[0];

    // inputs Properties Product
    const [dataProperties, setDataProperties] = useState([
        { color: "", size: "", quantity: "", purchase_price: "", stock_weight: "", weight_unit: "kg", purchase_date: today, source: "", warehouse: "", receipts: [], status: "Disponible" },
    ]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);

    const colorText_BoxProperties = useColorModeValue("gray", "gray.400");
    const colorInput_BoxProperties = useColorModeValue("black", "gray.400");
    const colorBorderInput_BoxProperties = useColorModeValue(
        "gray.300",
        "gray.500"
    );

    const addProperty = () => {
        setDataProperties([
            ...dataProperties,
            { color: "", size: "", quantity: "", purchase_price: "", stock_weight: "", weight_unit: "kg", purchase_date: today, source: "", warehouse: "", receipts: [], status: "Disponible" },
        ]);
    };

    const removeProperty = (index) => {
        const listProp = [...dataProperties];
        listProp.splice(index, 1);
        setDataProperties(listProp);
    };


    const handleChangeProperty = (e, index) => {
        const { name, value } = e.target;
        const listProp = [...dataProperties];

        if (name === "purchase_price") {
            const formattedValue = handlePriceChange(value);
            if (formattedValue !== null) {
                listProp[index][name] = formattedValue;
                setDataProperties(listProp);
            }
        } else if (name === "quantity") {
            if (value === '' || /^\d+$/.test(value)) {
                listProp[index][name] = value;
                setDataProperties(listProp);
            }
        } else if (name === "stock_weight") {
            if (value === '') {
                listProp[index][name] = '';
                setDataProperties(listProp);
                return;
            }
            let normalized = value.replace(',', '.');
            const regex = /^\d*\.?\d{0,3}$/;
            if (regex.test(normalized)) {
                listProp[index][name] = normalized;
                setDataProperties(listProp);
            }
        } else {
            listProp[index][name] = value;
            setDataProperties(listProp);
        }
    };


    const calculateTotalQuantity = () => {
        let totalQuantity = 0;
        dataProperties.forEach((item) => {
            // Convertir la quantité en nombre et l'ajouter au total
            totalQuantity += parseInt(item.quantity || 0); // Si la quantité est vide, on prend 0
        });
        return totalQuantity;
    };

    const addTotalQntt = () => {
        let totalQuantity = 0;
        dataProperties.forEach((item) => {
            // Convertir la quantité en nombre et l'ajouter au total
            totalQuantity += parseInt(item.quantity || 0); // Si la quantité est vide, on prend 0
        });
        setTotalQuantity(totalQuantity);
    };

    const removeTotlaQntt = (qtt) => {
        if (qtt) {
            setTotalQuantity(totalQuantity - parseInt(qtt));
        }
    };

    const addTotalPrice = () => {
        let totalPrice = 0;
        dataProperties.forEach((item) => {
            // Convertir le prix en nombre et l'ajouter au total
            totalPrice += formatPriceForBackend(item.purchase_price || 0); // Si le prix est vide, on prend 0
        });
        setTotalPrice(totalPrice.toFixed(2));
    };

    const removeTotlaPrice = (prix) => {
        if (prix) {
            setTotalPrice((parseFloat(totalPrice) - formatPriceForBackend(prix)).toFixed(2));
        }
    };


    // Background & color useColor
    const bg = useColorModeValue("white", "#212835")
    const bg2 = useColorModeValue("gray.50", "#212835")
    const colorTxt = useColorModeValue("gray", "gray.400")
    const colorTxt2 = useColorModeValue("gray.500", "gray.400")
    const colorTxt3 = useColorModeValue("gray", "gray.200")
    const borderColor = useColorModeValue("gray.500", "gray.400")

    useEffect(() => {
        // console.log(user);
    })

    const isNumeric = (value) => {
        return /^\d+$/.test(value); // Valide les entiers positifs
    };

    const isValidPrice = (value) => {
        return /^\d*\.?\d{0,2}$/.test(value.toString().replace(',', '.'));
    };

    // Back-End
    const addProduct = async () => {
        try {

            const isStockEmpty = dataProperties.length === 1 && !dataProperties[0].quantity && !dataProperties[0].purchase_price && !dataProperties[0].color && !dataProperties[0].size;

            if (!isStockEmpty) {
                const hasInvalidNumbers = dataProperties.some(item => {
                    return !isNumeric(item.quantity) || !isValidPrice(item.purchase_price);
                });

                if (hasInvalidNumbers) {
                    toast({
                        description: t("Le champ quantité doit contenir uniquement des chiffres et le prix d'achat un montant valide (ex: 10.22)"),
                        status: 'error',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                    return;
                }

                const hasEmptyRequiredFields = dataProperties.some(item => {
                    return !item.quantity || !item.purchase_price;
                });

                if (hasEmptyRequiredFields) {
                    toast({
                        description: t("Les champs quantité et prix d'achat sont obligatoires pour toutes les variantes, ou laissez tout vide pour créer sans stock."),
                        status: 'error',
                        variant: 'left-accent',
                        duration: 3000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                    return;
                }
            }

            if (imageListe.length === 0) {
                setMessageErrImages(t('Il faut ajouter au moins une image !'))
                setActiveStep(0)
                return;
            }

            if (!titreProduit) {
                setMessageErrTitle(t('Il faut ajouter un titre !'))
                setActiveStep(1)
                return
            }

            if (parseInt(dataSubscriptionUser?.subscription?.products_count) === parseInt(dataSubscriptionUser?.products_limit)) {
                toast({
                    description: t("Vous avez atteint la limite du produit de votre abonnement"),
                    status: 'warning',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return
            }

            //fonction si les champs de dataProperties sont vides
            const areAllFieldsEmpty = () => {
                return dataProperties.every(item => {
                    return Object.values(item).every(value => {
                        if (Array.isArray(value)) return value.length === 0;
                        if (value === null || value === undefined) return true;
                        return String(value).trim() === '';
                    });
                });
            };

            // console.log(areAllFieldsEmpty());

            const formData = new FormData()
            formData.append('client_id', user?.id)
            formData.append('title', titreProduit)
            formData.append('description', descriptionProduit)
            formData.append('total_quantity', totalQuantity)
            formData.append('total_price', formatPriceForBackend(totalPrice))
            selectedCategory && formData.append('category', selectedCategory)
            formData.append('product_added_by', user.id)
            formData.append('business', currentBusiness?.id)
            formData.append('historique', JSON.stringify([
                {
                    'title': titreProduit,
                    'description': descriptionProduit,
                    'total_price': formatPriceForBackend(totalPrice),
                    'category': selectedCategory || null,
                    'user': user.id,
                    'created_at': new Date().toLocaleString()
                }
            ]))
            formData.append('stock', isStockEmpty ? JSON.stringify([]) : JSON.stringify(dataProperties))
            dataProperties.forEach((item, index) => {
                if (item.receipts && item.receipts.length > 0) {
                    item.receipts.forEach((file, fileIndex) => {
                        formData.append(`recu_${index}_${fileIndex}`, file);
                    });
                }
            });

            // Utilisez await pour attendre la réponse de la requête
            const response = await axiosClient.post('/products/create_product/', formData)
            const data = response.data;

            // console.log("Réponse reçue:", data);

            if (data.error === 'Client is disabled.' && data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
                return
            }
            else if (data.error === 'No active subscription') {
                toast({
                    description: data.message,
                    variant: 'left-accent',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return
            }
            else if (data.error === 'Subscription expired') {
                toast({
                    description: data.message,
                    variant: 'left-accent',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return
            }
            else if (data.error === 'Products limit reached') {
                toast({
                    description: data.message,
                    variant: 'left-accent',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return
            }
            if (data.message === "Product created successfully") {
                toast({
                    description: t("Produit ajouté avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                getAbonnementClient()
                addStockImage(data.product)
            }
        } catch (error) {
            // // console.error("Erreur lors de l'ajout du produit:", error);
            toast({
                description: t("Une erreur s'est produite lors de l'ajout du produit"),
                status: 'error',
                variant: 'left-accent',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        }
    }

    const addStockImage = async (data) => {
        const formDataArray = imageListe.map((image) => {
            const formData = new FormData();
            formData.append("product", data.id);
            formData.append("image", image);
            return formData;
        });

        await Promise.all(formDataArray.map(async (formData) => {
            return await axiosClient.post("/productImages/", formData);
        }));

        navigate('/My_Stock');
    }

    const addStock = (data) => {

        const formDataArray = dataProperties.map((val) => {
            const formData = new FormData();
            formData.append("color", val.color);
            formData.append("size", val.size);
            formData.append("quantity", val.quantity);
            formData.append("purchase_price", formatPriceForBackend(val.purchase_price));

            formData.append("product", data.id);
            if (val.stock_weight) formData.append("stock_weight", val.stock_weight);
            if (val.weight_unit) formData.append("weight_unit", val.weight_unit);
            if (val.purchase_date) formData.append("purchase_date", val.purchase_date);
            if (val.source) formData.append("source", val.source);
            if (val.warehouse) formData.append("warehouse", val.warehouse);
            if (val.recu) formData.append("recu", val.recu);
            if (val.status) formData.append("status", val.status);
            formData.append('stock_added_by', user.id)
            formData.append('historique', JSON.stringify([
                {
                    'color': val.color,
                    'size': val.size,
                    'quantity': val.quantity,
                    'purchase_price': formatPriceForBackend(val.purchase_price),

                    'stock_weight': val.stock_weight,
                    'weight_unit': val.weight_unit,
                    'purchase_date': val.purchase_date,
                    'source': val.source,
                    'warehouse': val.warehouse,
                    'status': val.status,
                    'user': user.id,
                    'created_at': new Date().toLocaleString()
                }
            ]))

            return formData;
        });

        Promise.all(formDataArray.map(async (formData, index) => {

            return await axiosClient.post("/stock/", formData
                // , {
                //     onUploadProgress: (data) => {
                //         progressBar = Math.round((data.loaded / data.total) * 100);
                //         setUploaded({
                //             item: index,
                //             uploaded,
                //             progressBar,
                //         });
                //     },
                // }
            )
                .then((response) =>
                //  ({
                //     id: response?.data.id,
                //     service: data.id,
                //     image: response?.data.image,


                // })
                {
                    // if (index === formDataArray.length - 1) { navigate('/apa-agency-services') }

                }
                );

        }))
    }

    return (
        <Stack>
            <Flex>
                <Box w="90%" pt="12px" mb={8}>

                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem >
                            <BreadcrumbLink onClick={() => navigate('/My_Stock')}>{t("Gestion stock")}</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Nouveau stock")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>
            </Flex>
            <Flex justify="center">
                <Stepper w={{ base: "100%", lg: "75%" }} index={activeStep}>
                    {steps.map((step, index) => (
                        <Step key={index}>
                            <StepIndicator>
                                <StepStatus
                                    complete={<StepIcon />}
                                    incomplete={<StepNumber />}
                                    active={<StepNumber />}
                                />
                            </StepIndicator>

                            <Box flexShrink="0">
                                <StepTitle>{step.title}</StepTitle>
                                <StepDescription>{step.description}</StepDescription>
                            </Box>

                            <StepSeparator />
                        </Step>
                    ))}
                </Stepper>
            </Flex>

            <Flex justify={"center"}>
                <Box
                    bg={bg}
                    borderWidth="1px"
                    rounded="lg"
                    w={{ base: "100%", lg: "75%" }}
                    shadow="1px 1px 3px rgba(0,0,0,0.3)"
                    p={6}
                    m="10px auto"
                    as="form"
                >
                    {
                        activeStep === 0 ?

                            <>
                                <Stack
                                    pt={3}
                                    px={{ base: 2, lg: 7 }}
                                    bg={bg}
                                    rounded="lg"
                                >
                                    <Text color={colorTxt}>
                                        {t("Ajouter les images jusqu'au 5 images")}
                                    </Text>

                                    {messageErrImages && <Alert status='error' variant='left-accent'>
                                        <AlertIcon />
                                        {messageErrImages}
                                    </Alert>}

                                    <Flex
                                        align={"center"}
                                        w={"100%"}
                                        // gap={2}
                                        px={5}
                                        py={5}
                                        justify={"center"}
                                        // py={{ base: 3, xl: 0 }}

                                        minHeight={"100px"}
                                    // style={{
                                    //     border: '1px dashed lightgray',
                                    // }}
                                    >
                                        {selectedImageList.length === 0 && (
                                            <Flex

                                            // align={'center'}
                                            // justify={'center'}
                                            // style={{ width: '100%' }}
                                            >
                                                <Button
                                                    size={{ base: "sm", md: "md" }}
                                                    ml={{ base: 0, lg: 5 }}
                                                    colorScheme="purple"
                                                    variant="outline"
                                                >
                                                    <AiOutlinePlus style={{ fontSize: "18px", marginRight: 2 }} />
                                                    <Text ml="2" fontWeight="lighter">
                                                        {t("Télécharger des images")}
                                                    </Text>
                                                    <input
                                                        key={inputKey}
                                                        multiple
                                                        type="file"
                                                        id="inputGroupFile01"
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            height: "100%",
                                                            opacity: 0,
                                                            cursor: "pointer",
                                                        }}
                                                        onMouseEnter={(e) => (e.target.style.cursor = "pointer")}
                                                        onMouseLeave={(e) =>
                                                            (e.target.style.cursor = "context-menu")
                                                        }
                                                        onChange={handleChangeImage}
                                                        accept="image/png,image/jpg,image/jpeg,image/webp"
                                                    />
                                                </Button>
                                            </Flex>
                                        )}
                                        <Grid
                                            templateColumns={{
                                                base: "repeat(1,1fr)",
                                                sm: "repeat(3,1fr)",
                                                md: "repeat(3,1fr)",
                                                lg: "repeat(4,1fr)",
                                                xl: "repeat(5,1fr)",
                                            }}
                                            gap={3}
                                        >
                                            {selectedImageList &&
                                                selectedImageList.map((val, key) => (
                                                    <GridItem>
                                                        <Flex
                                                            flexDirection={"row"}
                                                            w={"100%"}
                                                            key={key}
                                                            style={{
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Avatar
                                                                size={"xl"}
                                                                src={val}
                                                                borderRadius={"10px"}
                                                                style={{
                                                                    objectFit: "contain",
                                                                }}
                                                            >
                                                                <AvatarBadge
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        position: "absolute",
                                                                        fontSize: 10,

                                                                        cursor: "pointer",
                                                                        // color: '#c7c4c4',
                                                                        background: "black",
                                                                        right: "-5%",
                                                                        top: "-5%",
                                                                    }}
                                                                >
                                                                    <CloseIcon
                                                                        onClick={() => {
                                                                            // deleteimg(key)
                                                                            const newImageList = imageListe;
                                                                            const deleteItemImageListe = newImageList.splice(
                                                                                key,
                                                                                1
                                                                            );
                                                                            setSelectedImageList(
                                                                                selectedImageList.filter((e) => e !== val)
                                                                            );
                                                                            setimageListe(newImageList);
                                                                        }}
                                                                    />
                                                                </AvatarBadge>
                                                            </Avatar>
                                                        </Flex>
                                                    </GridItem>
                                                ))}

                                            {selectedImageList.length > 0 && selectedImageList.length < 5 && (
                                                <Flex
                                                    align={"center"}
                                                    justify={"center"}
                                                    style={{
                                                        height: "100px",
                                                    }}
                                                >
                                                    <Button colorScheme="blue" variant="outline">
                                                        <AiOutlinePlus style={{ fontSize: 22 }} />
                                                        <input
                                                            key={inputKey}
                                                            multiple
                                                            type="file"
                                                            onChange={handleChangeImage}
                                                            style={{
                                                                position: "absolute",
                                                                width: "100%",
                                                                height: "100%",
                                                                top: 0,
                                                                left: 0,
                                                                opacity: 0,
                                                            }}
                                                            accept="image/png,image/jpg,image/jpeg,image/webp"
                                                        />
                                                    </Button>
                                                </Flex>
                                            )}
                                        </Grid>
                                    </Flex>
                                </Stack>
                            </>
                            :
                            activeStep === 1
                                ?

                                <>
                                    <Stack
                                        mt={3}
                                        px={{ base: 2, lg: 7 }}
                                        bg={bg}
                                        rounded="lg"
                                    >
                                        {/* <Text color={useColorModeValue('gray', 'gray.400')}></Text> */}
                                        <Heading
                                            color={colorTxt2}
                                            w="100%"
                                            fontSize={"3xl"}
                                            textAlign={"center"}
                                            fontWeight="normal"
                                            mb={5}
                                        >
                                            {t("Informations du produit")}
                                        </Heading>

                                        {messageErrTitle && <Alert status='error' variant='left-accent'>
                                            <AlertIcon />
                                            {messageErrTitle}
                                        </Alert>}

                                        <Flex mt={2}>
                                            <FormControl display={"flex"} flexDirection={{ base: 'column', md: 'row' }} id="titre" isRequired>
                                                <FormLabel
                                                    color={colorTxt}
                                                    w={"80%"}
                                                >
                                                    {t("Titre")}
                                                </FormLabel>
                                                <Input
                                                    id="titre"
                                                    name="titreProduit"
                                                    type="text"
                                                    // color={colorTxt2}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    placeholder={t("Titre")}
                                                    value={titreProduit}
                                                    onChange={e => setTitreProduit(e.target.value)}
                                                />
                                            </FormControl>
                                        </Flex>

                                        <Flex mt={2}>
                                            <FormControl display={"flex"} flexDirection={{ base: 'column', md: 'row' }} id="titre">
                                                <FormLabel
                                                    color={colorTxt}
                                                    w={"80%"}
                                                >
                                                    {t("Catégorie")}
                                                </FormLabel>
                                                <div style={{ width: '104%' }}>
                                                    <Select
                                                        onChange={e => setSelectedCategory(e.target.value)}
                                                        placeholder={t("Choisissez une catégorie")}
                                                        value={selectedCategory}
                                                        isClearable
                                                        isSearchable
                                                        name="category"
                                                    >
                                                        {categoriesOptions.map((val, key) => {
                                                            return (
                                                                <option key={key} value={val.value}>{val.label}</option>
                                                            )
                                                        })}
                                                    </Select>
                                                </div>
                                            </FormControl>
                                        </Flex>

                                        <Flex mt={3}>
                                            <FormControl display={"flex"} flexDirection={{ base: 'column', md: 'row' }} id="description">
                                                <FormLabel
                                                    color={colorTxt}
                                                    w={"80%"}
                                                >
                                                    Description
                                                </FormLabel>
                                                <Textarea
                                                    id="description"
                                                    name="descriptionProduit"
                                                    // color={colorTxt2}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    resize={"none"}
                                                    placeholder="Description"
                                                    value={descriptionProduit}
                                                    onChange={e => setDescriptionProduit(e.target.value)}
                                                ></Textarea>
                                            </FormControl>
                                        </Flex>

                                    </Stack>
                                </>
                                :
                                activeStep === 2 && <>
                                    <Stack
                                        mt={3}
                                        pt={3}
                                        px={{ base: 2, lg: 7 }}
                                        bg={bg}
                                        rounded="lg"
                                        pb={5}
                                    >
                                        {/* <Text color={useColorModeValue('gray', 'gray.400')}>Propriétés produit</Text> */}
                                        <Heading
                                            color={borderColor}
                                            w="100%"
                                            fontSize={"3xl"}
                                            textAlign={"center"}
                                            fontWeight="normal"
                                            mb={5}
                                        >
                                            {t("Propriétés du produit")}
                                        </Heading>
                                        {dataProperties.map((val, key) => {
                                            return (
                                                <Box key={key} mt={2}>
                                                    <Flex gap={5}>
                                                        <FormControl id="couleur">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t("Couleur")}
                                                            </FormLabel>
                                                            <Input
                                                                id="couleur"
                                                                name="color"
                                                                type="text"
                                                                color={colorInput_BoxProperties}
                                                                borderColor={colorBorderInput_BoxProperties}
                                                                _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                                placeholder={t("Couleur")}
                                                                value={val.color}
                                                                onChange={(e) => handleChangeProperty(e, key)}
                                                            />
                                                        </FormControl>
                                                        <FormControl id="size">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t("Taille")}
                                                            </FormLabel>
                                                            <Input
                                                                id="size"
                                                                name="size"
                                                                type="text"
                                                                color={colorInput_BoxProperties}
                                                                borderColor={colorBorderInput_BoxProperties}
                                                                _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                                placeholder={t("Taille")}
                                                                value={val.size}
                                                                onChange={(e) => handleChangeProperty(e, key)}
                                                            />
                                                        </FormControl>
                                                    </Flex>
                                                    <Flex gap={5} mt={3}>
                                                        <FormControl id="quantity">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t('Quantité')}
                                                            </FormLabel>
                                                            <Input
                                                                id="quantity"
                                                                name="quantity"
                                                                type="text"
                                                                color={colorInput_BoxProperties}
                                                                borderColor={colorBorderInput_BoxProperties}
                                                                _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                                placeholder={t("Quantité")}
                                                                value={val.quantity}
                                                                onChange={(e) => {
                                                                    handleChangeProperty(e, key);
                                                                    addTotalQntt();
                                                                }}
                                                            />
                                                        </FormControl>
                                                        <FormControl id="price">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"} display={"flex"} alignItems={"center"} gap={1}>
                                                                <Text>{t("Prix d'achat")}</Text> /
                                                                <Text fontSize={12} >{currentBusiness?.currency}</Text>
                                                            </FormLabel>
                                                            <Input
                                                                id="price"
                                                                name="purchase_price"
                                                                type="text"
                                                                color={colorInput_BoxProperties}
                                                                borderColor={colorBorderInput_BoxProperties}
                                                                _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                                placeholder={t("Prix d'achat")}
                                                                value={val.purchase_price}
                                                                onChange={(e) => {
                                                                    handleChangeProperty(e, key);
                                                                    addTotalPrice();
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </Flex>
                                                    <Flex gap={5} mt={3}>
                                                        <FormControl id="stock_weight">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t("Poids du stock")}
                                                            </FormLabel>
                                                            <InputGroup>
                                                                <Input
                                                                    id="stock_weight"
                                                                    name="stock_weight"
                                                                    type="text"
                                                                    color={colorInput_BoxProperties}
                                                                    borderColor={colorBorderInput_BoxProperties}
                                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                                    placeholder={t("Poids")}
                                                                    value={val.stock_weight}
                                                                    onChange={(e) => handleChangeProperty(e, key)}
                                                                />
                                                                <Select
                                                                    name="weight_unit"
                                                                    w="120px"
                                                                    ml={2}
                                                                    value={val.weight_unit}
                                                                    onChange={(e) => handleChangeProperty(e, key)}
                                                                >
                                                                    <option value="kg">kg</option>
                                                                    <option value="g">g</option>
                                                                    <option value="lb">lb</option>
                                                                    <option value="oz">oz</option>
                                                                </Select>
                                                            </InputGroup>
                                                        </FormControl>
                                                        <FormControl id="source">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t("Source")}
                                                            </FormLabel>
                                                            <Input
                                                                id="source"
                                                                name="source"
                                                                type="text"
                                                                color={colorInput_BoxProperties}
                                                                borderColor={colorBorderInput_BoxProperties}
                                                                _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                                placeholder={t("Source")}
                                                                value={val.source}
                                                                onChange={(e) => handleChangeProperty(e, key)}
                                                            />
                                                        </FormControl>
                                                    </Flex>
                                                    <Flex gap={5} mt={3}>
                                                        <FormControl id="warehouse">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t("Entrepôt / Service")}
                                                            </FormLabel>
                                                            <Input
                                                                id="warehouse"
                                                                name="warehouse"
                                                                type="text"
                                                                color={colorInput_BoxProperties}
                                                                borderColor={colorBorderInput_BoxProperties}
                                                                _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                                placeholder={t("Entrepôt / Service")}
                                                                value={val.warehouse}
                                                                onChange={(e) => handleChangeProperty(e, key)}
                                                            />
                                                        </FormControl>
                                                        <FormControl id="purchase_date" isRequired>
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t("Date d'achat")}
                                                            </FormLabel>
                                                            <Input
                                                                id="purchase_date"
                                                                name="purchase_date"
                                                                type="date"
                                                                max={today}
                                                                color={colorInput_BoxProperties}
                                                                borderColor={colorBorderInput_BoxProperties}
                                                                _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                                value={val.purchase_date}
                                                                onChange={(e) => handleChangeProperty(e, key)}
                                                            />
                                                        </FormControl>
                                                        <FormControl id="status">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t("Statut")}
                                                            </FormLabel>
                                                            <Select
                                                                name="status"
                                                                color={colorInput_BoxProperties}
                                                                borderColor={colorBorderInput_BoxProperties}
                                                                value={val.status}
                                                                onChange={(e) => handleChangeProperty(e, key)}
                                                            >
                                                                <option value="Disponible">{t("Disponible")}</option>
                                                                <option value="Épuisé">{t("Épuisé")}</option>
                                                                <option value="En transit">{t("En transit")}</option>
                                                                <option value="Endommagé">{t("Endommagé")}</option>
                                                            </Select>
                                                        </FormControl>
                                                    </Flex>
                                                    <Flex gap={5} mt={3}>
                                                        <FormControl id="recu">
                                                            <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                                {t("Reçu (Fichier)")}
                                                            </FormLabel>
                                                            <Box
                                                                border="2px dashed"
                                                                borderColor="gray.200"
                                                                p={4}
                                                                rounded="xl"
                                                                textAlign="center"
                                                                cursor="pointer"
                                                                _hover={{ borderColor: 'purple.400', bg: 'purple.50' }}
                                                                position="relative"
                                                            >
                                                                <Input
                                                                    id="receipts"
                                                                    name="receipts"
                                                                    type="file"
                                                                    multiple
                                                                    accept="image/*,.pdf"
                                                                    opacity={0}
                                                                    position="absolute"
                                                                    top={0}
                                                                    left={0}
                                                                    w="100%"
                                                                    h="100%"
                                                                    cursor="pointer"
                                                                    onChange={async (e) => {
                                                                        const files = Array.from(e.target.files);
                                                                        const validFiles = [];
                                                                        const extensions = ['.png', '.jpg', '.jpeg', '.webp', '.pdf'];
                                                                        
                                                                        if (dataProperties[key].receipts.length + files.length > 5) {
                                                                            toast({ description: t("Max 5 fichiers"), status: 'warning' });
                                                                            return;
                                                                        }

                                                                        for (const file of files) {
                                                                            const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                                                                            if (!extensions.includes(ext)) {
                                                                                toast({ description: `${file.name}: ${t("Format non supporté")}`, status: 'error' });
                                                                                continue;
                                                                            }
                                                                            if (file.name.length > 50) {
                                                                                toast({ description: `${file.name}: ${t("Nom trop long (max 50)")}`, status: 'error' });
                                                                                continue;
                                                                            }
                                                                            if (file.size > 4 * 1024 * 1024) {
                                                                                toast({ description: `${file.name}: ${t("Fichier trop volumineux (max 4Mo)")}`, status: 'error' });
                                                                                continue;
                                                                            }

                                                                            if (file.type.startsWith('image/')) {
                                                                                const resized = await new Promise((resolve) => {
                                                                                    Resizer.imageFileResizer(
                                                                                        file, 800, 800, 'JPEG', 80, 0,
                                                                                        (uri) => resolve(uri), 'file'
                                                                                    );
                                                                                });
                                                                                validFiles.push(resized);
                                                                            } else {
                                                                                validFiles.push(file);
                                                                            }
                                                                        }
                                                                        const listProp = [...dataProperties];
                                                                        listProp[key]['receipts'] = [...listProp[key]['receipts'], ...validFiles];
                                                                        setDataProperties(listProp);
                                                                    }}
                                                                />
                                                                <AttachmentIcon color="gray.400" mb={2} />
                                                                <Text fontSize="sm" color="gray.500">
                                                                    {val.receipts.length > 0 ? `${val.receipts.length} ${t("fichiers sélectionnés")}` : t("Cliquez ou glissez des fichiers ici")}
                                                                </Text>
                                                            </Box>
                                                            <Flex wrap="wrap" gap={2} mt={2}>
                                                                {val.receipts.map((f, i) => (
                                                                    <Badge key={i} colorScheme="purple" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                                                    <a href={URL.createObjectURL(f)} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                                        <AttachmentIcon mr={1} fontSize="10px" />
                                                                        {f.name.substring(0, 10)}...
                                                                    </a>
                                                                        <IconButton size="xs" ml={2} icon={<CloseIcon />} variant="ghost" _hover={{ bg: 'red.100', color: 'red.500' }} onClick={() => {
                                                                            const listProp = [...dataProperties];
                                                                            listProp[key]['receipts'] = listProp[key]['receipts'].filter((_, idx) => idx !== i);
                                                                            setDataProperties(listProp);
                                                                        }} />
                                                                    </Badge>
                                                                ))}
                                                            </Flex>
                                                        </FormControl>
                                                    </Flex>

                                                    <Flex justifyContent={"end"} mt={3} gap={3}>
                                                        <Flex justifyContent={"end"} gap={3}>
                                                            {dataProperties.length > 1 && (
                                                                <Button
                                                                    colorScheme="red"
                                                                    size={"sm"}
                                                                    variant={"outline"}
                                                                    onClick={() => {
                                                                        removeProperty(key);
                                                                        removeTotlaQntt(val.quantity);
                                                                        removeTotlaPrice(val.price);
                                                                    }}
                                                                >
                                                                    {t('Supprimer')}
                                                                </Button>
                                                            )}
                                                            {dataProperties.length - 1 === key && (
                                                                <Button
                                                                    colorScheme="green"
                                                                    size={"sm"}
                                                                    variant={"outline"}
                                                                    onClick={() => {
                                                                        addProperty();
                                                                    }}
                                                                >
                                                                    Plus
                                                                </Button>
                                                            )}
                                                        </Flex>
                                                    </Flex>
                                                </Box>
                                            );
                                        })}
                                    </Stack>

                                    <Stack
                                        mt={3}
                                        pt={3}
                                        px={7}
                                        bg={bg2}
                                        rounded="lg"
                                        pb={5}
                                    >
                                        <Text
                                            color={colorTxt}
                                        >Total</Text>
                                        <Flex justifyContent={"space-between"}>
                                            <Flex mt={2} gap={2}>
                                                <Text
                                                    textTransform={"uppercase"}
                                                    color={colorTxt}
                                                >
                                                    {t("Quantité")} :{" "}
                                                </Text>
                                                <Text
                                                    color={colorTxt3}
                                                >
                                                    {totalQuantity}
                                                </Text>
                                            </Flex>
                                            <Flex mt={2} gap={2} alignItems="center">
                                                <Flex gap={1} alignItems="center">
                                                    <Text
                                                        textTransform={"uppercase"}
                                                        color={colorTxt}
                                                    >
                                                        {t("Prix")} /
                                                    </Text>
                                                    <Text fontSize={12} >{currentBusiness?.currency}</Text>:
                                                </Flex>
                                                <Input
                                                    id="totalPrice"
                                                    name="totalPrice"
                                                    type="text"
                                                    color={colorInput_BoxProperties}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    placeholder={t("Prix total")}
                                                    value={totalPrice}
                                                    onChange={(e) => {
                                                        const formattedValue = handlePriceChange(e.target.value);
                                                        if (formattedValue !== null) {
                                                            setTotalPrice(formattedValue);
                                                        }
                                                    }}
                                                    w="120px"
                                                    size="sm"
                                                />
                                            </Flex>
                                        </Flex>
                                    </Stack>
                                </>
                    }
                    <ButtonGroup mt="5%" w="100%">
                        <Flex w="100%" justifyContent="space-between">
                            <Flex>
                                <Button
                                    onClick={() => {
                                        setActiveStep(activeStep - 1)
                                    }}
                                    isDisabled={activeStep === 0}
                                    colorScheme="blue"
                                    variant="solid"
                                    w="7rem"
                                    mr="5%"
                                >
                                    {t("Précédent")}
                                </Button>
                                <Button
                                    w="7rem"
                                    isDisabled={activeStep === 2}
                                    onClick={() => {
                                        if (activeStep === 0 && selectedImageList.length === 0) {
                                            toast({
                                                description: t("Veuillez sélectionner au moins une image pour continuer."),
                                                status: 'error',
                                                variant: 'left-accent',
                                                duration: 2000,
                                                isClosable: true,
                                                position: 'bottom-right'
                                            });
                                            return;
                                        }
                                        if (activeStep === 1 && !titreProduit) {
                                            toast({
                                                description: t("Veuillez saisir un titre pour le produit."),
                                                status: 'error',
                                                variant: 'left-accent',
                                                duration: 2000,
                                                isClosable: true,
                                                position: 'bottom-right'
                                            });
                                            return;
                                        }
                                        setActiveStep(activeStep + 1)
                                    }}
                                    colorScheme="blue"
                                    variant="outline"
                                >
                                    {t("Suivant")}
                                </Button>
                            </Flex>

                        </Flex>
                    </ButtonGroup>

                </Box>
                {/* <Box w={{ base: '100%', md: '80%', lg: '70%' }}>
                     
  
                      
  
                     
  
                      <Flex mt={5} justifyContent={'end'}>
                          <Button colorScheme='purple' size={"sm"} variant={'outline'} onClick={() => {
                          }}>Ajouter</Button>
                      </Flex>
  
                  </Box> */}
            </Flex>
            <Flex
                justify={'center'}>
                <Flex w={{ base: '100%', lg: '75%' }} justify={"end"}>
                    {activeStep === 2 ? (
                        // <Button
                        //     w="7rem"
                        //     colorScheme="red"
                        //     variant="solid"
                        //     onClick={() => {
                        //         toast({
                        //             title: 'Account created.',
                        //             description: "We've created your account for you.",
                        //             status: 'success',
                        //             duration: 3000,
                        //             isClosable: true,
                        //         })
                        //     }}>
                        //     Ajouter
                        // </Button>
                        <Button
                            w="7rem"
                            colorScheme="purple"
                            size={"md"}
                            variant={"outline"}
                            onClick={addProduct}
                        >
                            {t("Ajouter")}
                        </Button>
                    ) : null}
                </Flex>
            </Flex>
        </Stack>
    );
}

export default AddStock;